import { mapMaybe } from '@execonline-inc/collections';
import { always } from '@kofno/piper';
import { just, Maybe } from 'maybeasy';
import { findLink } from '../../../../LinkyLinky';
import { Rel, Link } from '../../../../Resource/Types';
import { TPlainTextKey } from '../../../../Translations';

export interface MenuItemContent {
  content: TPlainTextKey;
  to: string;
  rel: Rel;
}

type ToMenuItem = (links: ReadonlyArray<Link>) => Maybe<MenuItemContent>;

const toMenuItem =
  (content: MenuItemContent) =>
  (links: ReadonlyArray<Link>): Maybe<MenuItemContent> =>
    just(links).andThen(findLink(content.rel)).map(always(content));

const toLearningDesignsMenuItem = toMenuItem({
  content: 'Learning Collections',
  to: '/learning_collections',
  rel: 'learning-collections',
});

const toReportsMenuItem = toMenuItem({
  content: 'Reports',
  to: '/reports',
  rel: 'reports',
});

const toPeopleMenuItem = toMenuItem({
  content: 'People',
  to: '/people',
  rel: 'participants',
});

const toProductsMenuItem = toMenuItem({
  content: 'Products',
  to: '/products',
  rel: 'products',
});

const toHomeMenuItem = toMenuItem({
  content: 'Home',
  to: '/home',
  rel: 'tasks',
});

const toSingleSignOnMenuItem = toMenuItem({
  content: 'Single Sign-On',
  to: '/single_sign_on',
  rel: 'sso-configurations',
});

const linksToMenuItems: ToMenuItem[] = [
  toHomeMenuItem,
  toLearningDesignsMenuItem,
  toReportsMenuItem,
  toPeopleMenuItem,
  toProductsMenuItem,
  toSingleSignOnMenuItem,
];

const menuItems = (links: ReadonlyArray<Link>): ReadonlyArray<MenuItemContent> =>
  mapMaybe<ToMenuItem, MenuItemContent>((fn) => fn(links))(linksToMenuItems);

export { menuItems };
